import { IMAGES } from "@/data";

export const CASE_STUDIES = [
  {
    slug: "meridian-3pl",
    company: "Meridian 3PL",
    industry: "Third-party logistics",
    image: IMAGES.containers,
    headline: "42% fewer stock errors across four sites.",
    summary: "A national 3PL unified inventory, pallets and billing for every customer on one platform — and stopped guessing.",
    metrics: [
      { k: "Stock errors", v: "-42%" },
      { k: "Sites live", v: "4" },
      { k: "Onboarding time", v: "-60%" },
    ],
    quote: "We stopped guessing. Stockaris gave us a live view of stock, pallets and capacity in one place — for every customer.",
    author: "Operations Director",
    authorRole: "Meridian 3PL",
    challenge: "Four warehouses, a dozen customers, and a different spreadsheet for each. Stock counts were only trustworthy the day after a manual audit, and new-customer onboarding meant weeks of setup.",
    solution: [
      "Rolled out Stockaris across all four sites with complete per-customer data separation",
      "Replaced end-of-day reports with real-time inventory and location control",
      "Standardised inbound and outbound workflows with RF scan validation",
      "Automated activity-based billing per customer",
    ],
    results: [
      "42% reduction in stock errors within the first quarter",
      "New customers onboarded in days instead of weeks",
      "A single source of truth across every site and client",
    ],
  },
  {
    slug: "harvest-foods",
    company: "Harvest Foods",
    industry: "FMCG distribution",
    image: IMAGES.vizWarehouse,
    headline: "18% warehouse capacity reclaimed before peak.",
    summary: "An FMCG distributor used the Master Planner to model peak season — and found the space they didn't know they had.",
    metrics: [
      { k: "Capacity reclaimed", v: "+18%" },
      { k: "Peak stockouts", v: "-31%" },
      { k: "Planning horizon", v: "12 mo" },
    ],
    quote: "The Master Planner flagged a capacity crunch before Black Friday. That single insight paid for the year.",
    author: "Head of Supply Chain",
    authorRole: "Harvest Foods",
    challenge: "Every peak season ended the same way — aisles blocked, overflow pallets on the floor, and last-minute scrambles for external storage that ate into margin.",
    solution: [
      "Modelled demand and inbound container schedules in the Master Planner",
      "Simulated peak scenarios months ahead to surface capacity warnings early",
      "Optimised slotting and space allocation from live utilisation data",
    ],
    results: [
      "18% of warehouse capacity reclaimed through smarter slotting",
      "31% fewer stockouts during peak trading",
      "Zero emergency external-storage costs last season",
    ],
  },
  {
    slug: "polar-group",
    company: "Polar Group",
    industry: "Cold storage",
    image: IMAGES.pallets,
    headline: "$140k in pallet losses recovered in year one.",
    summary: "A cold-storage operator brought CHEP and LOSCAM reconciliation into Stockaris and turned pallet variance into recovered cash.",
    metrics: [
      { k: "Losses recovered", v: "$140k" },
      { k: "Reconciliation", v: "Automatic" },
      { k: "Variance found", v: "100%" },
    ],
    quote: "Pallet reconciliation used to be a spreadsheet nightmare. Now the variance finds itself.",
    author: "Warehouse Manager",
    authorRole: "Polar Group",
    challenge: "Pallet accounts with CHEP and LOSCAM never matched the provider statements, and nobody could trace where the losses were happening. Write-offs quietly grew every quarter.",
    solution: [
      "Tracked every pallet movement — receive, store, pick, dispatch, return",
      "Auto-reconciled internal balances against provider statements",
      "Drilled straight from any variance into its movement history",
    ],
    results: [
      "$140k of pallet losses identified and recovered in the first year",
      "Every variance now traceable to the exact movement",
      "Provider disputes resolved with an auditable trail",
    ],
  },
];

export const getCaseStudy = (slug) => CASE_STUDIES.find((c) => c.slug === slug);
